import { useEffect, useState } from "react";
import { KbvPluginService } from "@/services/kbvPluginService";
import hotIcon from "../assets/hot-icon.svg";
import arrowUp from "../assets/arrow-up.svg";
import fifaMask from "../assets/hot-league-fifa-corner-mask.svg";
import { absUrl, useSiteOrigin } from "../useSiteOrigin";
import { useDesktop } from "../useDesktop";
import "./hot-league.css";

const FIFA_WORLD_CUP_LEAGUE_SLUG = "fifa-world-cup";

function normalizeLeague(league) {
  if (!league) return null;
  const id = String(league.id ?? "");
  if (!id) return null;
  return {
    id,
    nameVN: league.nameVN || league.name || "",
    logo: league.logo || "",
    slug: league.slug ? String(league.slug) : "",
  };
}

export default function HotLeagueSideBar() {
  const desktop = useDesktop();
  const origin = useSiteOrigin();
  const [leagues, setLeagues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(true);
  const [path, setPath] = useState(() =>
    typeof window === "undefined" ? "" : window.location.pathname
  );

  useEffect(() => {
    const sync = () => setPath(window.location.pathname);
    window.addEventListener("popstate", sync);
    return () => window.removeEventListener("popstate", sync);
  }, []);

  useEffect(() => {
    if (!desktop) return undefined;
    let cancelled = false;
    setLoading(true);
    KbvPluginService.getHotLeagues()
      .then((list) => {
        if (cancelled) return;
        const rows = Array.isArray(list) ? list.map(normalizeLeague).filter(Boolean) : [];
        setLeagues(rows);
      })
      .catch(() => {
        if (!cancelled) setLeagues([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [desktop]);

  if (!desktop) return null;

  return (
    <aside className="kbv-home kbv-hot-league" aria-label="Hot leagues sidebar">
      <div className="kbv-hot-league__card">
        <div className="kbv-hot-league__head">
          <div className="kbv-hot-league__title">
            <img src={hotIcon} alt="" />
            <span>Giải đấu nổi bật</span>
          </div>
          <button
            type="button"
            className={`kbv-hot-league__toggle${expanded ? "" : " is-collapsed"}`}
            aria-label={expanded ? "Thu gọn" : "Mở rộng"}
            onClick={() => setExpanded((value) => !value)}
          >
            <img src={arrowUp} alt="" />
          </button>
        </div>
        {expanded ? (
          <div className="kbv-hot-league__list">
            {loading ? (
              <div className="kbv-hot-league__empty">Đang tải...</div>
            ) : leagues.length === 0 ? (
              <div className="kbv-hot-league__empty">Không có dữ liệu</div>
            ) : (
              leagues.map((league) => {
                const href = absUrl(origin, `/giai-dau/${league.slug || league.id}`);
                let active = false;
                try {
                  const url = new URL(href);
                  active =
                    url.origin === window.location.origin &&
                    (path === url.pathname || path.startsWith(`${url.pathname}/`));
                } catch {
                  active = false;
                }
                const fifa = league.slug === FIFA_WORLD_CUP_LEAGUE_SLUG;
                return (
                  <a
                    key={league.id}
                    href={href}
                    className={`kbv-hot-league__item${active ? " is-active" : ""}`}
                  >
                    {fifa ? (
                      <span className="kbv-hot-league__fifa">
                        <img src={fifaMask} alt="" />
                      </span>
                    ) : null}
                    <span className="kbv-hot-league__main">
                      <span className="kbv-hot-league__logo">
                        {league.logo ? (
                          <img src={league.logo} alt="" />
                        ) : (
                          <span className="kbv-hot-league__logo-fallback" />
                        )}
                      </span>
                      <span className="kbv-hot-league__name" title={league.nameVN}>
                        {league.nameVN}
                      </span>
                    </span>
                  </a>
                );
              })
            )}
          </div>
        ) : null}
      </div>
    </aside>
  );
}
